export default __webpack_public_path__ + "static/media/remerciement.b6871b89.svg";